import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const footerIntro = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "The online wholesale marketplace connecting independent retailers and brands around the world.",
    description: {
      text: "Introductory text in the footer of Faire's help center website",
      img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
    },
  });

export interface IFooterLink {
  text: string;
  path: string;
  target?: string;
}

interface IFooterColumn {
  title: string;
  links: IFooterLink[];
}

export const faireLinks = (
  strictLocalize: StrictLocalizeFunction
): IFooterColumn[] => [
  {
    title: strictLocalize({
      defaultMessage: "Company",
      description: {
        text: "Column header in the footer of Faire's help center website",
        img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
      },
    }),
    links: [
      {
        text: strictLocalize({
          defaultMessage: "About Us",
          description: {
            text: "Link text in the footer of Faire's help center website",
            img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
          },
        }),
        path: "/about",
      },
      {
        text: strictLocalize({
          defaultMessage: "Newsroom",
          description: {
            text: "Link text in the footer of Faire's help center website",
            img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
          },
        }),
        path: "https://news.faire.com/",
        target: "_blank",
      },
      {
        text: strictLocalize({
          defaultMessage: "Careers",
          description: {
            text: "Link text in the footer of Faire's help center website",
            img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
          },
        }),
        path: "/careers",
      },
      {
        text: strictLocalize({
          defaultMessage: "Partnerships",
          description: {
            text: "Link text in the footer of Faire's help center website",
            img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
          },
        }),
        path: "/partnerships",
      },
    ],
  },
  {
    title: strictLocalize({
      defaultMessage: "Support",
      description: {
        text: "Column header in the footer of Faire's help center website",
        img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
      },
    }),
    links: [
      {
        text: strictLocalize({
          defaultMessage: "Help Center",
          description: {
            text: "Link text in the footer of Faire's help center website",
            img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
          },
        }),
        path: "/support",
      },
      {
        text: strictLocalize({
          defaultMessage: "Open with Faire",
          description: {
            text: "Link text in the footer of Faire's help center website",
            img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
          },
        }),
        path: "/open-with-faire",
      },
      {
        text: strictLocalize({
          defaultMessage: "Faire Markets",
          description: {
            text: "Link text in the footer of Faire's help center website",
            img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
          },
        }),
        path: "/markets",
      },
      {
        text: strictLocalize({
          defaultMessage: "Apply to Sell",
          description: {
            text: "Link text in the footer of Faire's help center website",
            img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
          },
        }),
        path: "/brands",
      },
    ],
  },
  {
    title: strictLocalize({
      defaultMessage: "Connect",
      description: {
        text: "Column header in the footer of Faire's help center website",
        img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
      },
    }),
    links: [
      {
        text: "Blog",
        path: "/blog/",
        target: "_blank",
      },
      {
        text: "Instagram",
        path: "https://www.instagram.com/faire_wholesale/",
        target: "_blank",
      },
      {
        text: "Facebook",
        path: "https://www.facebook.com/fairewholesale/",
        target: "_blank",
      },
      {
        text: "Twitter",
        path: "https://twitter.com/faire_wholesale",
        target: "_blank",
      },
    ],
  },
];

export const policyLinks = (
  strictLocalize: StrictLocalizeFunction
): IFooterLink[] => [
  {
    text: `©${new Date().getFullYear()} Faire Wholesale, Inc.`,
    path: "/",
  },
  {
    text: strictLocalize({
      defaultMessage: "Terms of Service",
      description: {
        text: "Link text in the footer of Faire's help center website",
        img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
      },
    }),
    path: "/tos",
  },
  {
    text: strictLocalize({
      defaultMessage: "Privacy Policy",
      description: {
        text: "Link text in the footer of Faire's help center website",
        img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
      },
    }),
    path: "/privacy",
  },
  {
    text: strictLocalize({
      defaultMessage: "Cookie Policy",
      description: {
        text: "Link text in the footer of Faire's help center website",
        img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
      },
    }),
    path: "/privacy/cookies",
  },
  {
    text: strictLocalize({
      defaultMessage: "IP Policy",
      description: {
        text: "Link text in the footer of Faire's help center website",
        img: "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png",
      },
    }),
    path: "/copyright",
  },
];
